/**
 * Утилиты для работы с расходами
 */

/**
 * Генерирует временный ID для расхода
 */
export const generateTempId = (): string => {
  return `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * Проверяет, является ли ID временным
 */
export const isTempId = (id: string): boolean => {
  return id.startsWith('temp_');
};

/**
 * Форматирует сумму для отображения
 */
export const formatAmount = (amount: number): string => {
  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

/**
 * Форматирует дату для отображения
 */
export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('ru-RU');
};

/**
 * Получает следующий номер строки для Google Sheets
 * Начинаем с 7-й строки (согласно структуре таблицы)
 */
export const getNextSheetRow = (expenses: any[]): number => {
  const baseRow = 7; // Начальная строка для данных
  const existingRows = expenses
    .filter(expense => expense.sheet_row && expense.sheet_row >= baseRow)
    .map(expense => expense.sheet_row)
    .sort((a, b) => b - a);
  
  return existingRows.length > 0 ? existingRows[0] + 1 : baseRow;
};

/**
 * Создает объект расхода с временным ID
 */
export const createTempExpense = (data: any): any => {
  return {
    ...data,
    expense_id: generateTempId(),
    temp_id: generateTempId(),
    sheet_row: getNextSheetRow([]),
    synced: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  };
};
